import { render, staticRenderFns } from "./UploadImagesModal.vue?vue&type=template&id=51188154&scoped=true&"
import script from "./UploadImagesModal.vue?vue&type=script&lang=ts&"
export * from "./UploadImagesModal.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImagesModal.vue?vue&type=style&index=0&id=51188154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51188154",
  null
  
)

export default component.exports